"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pinConversations_1 = require("./pinConversations");
var pinItems_1 = require("./pinItems");
var owa_mail_list_store_1 = require("owa-mail-list-store");
/**
 * Toggle the row pinned status
 * @param rowKey row key to pin/unpin
 * @param tableViewId of the table that the row belong to
 * @param actionSource the action source
 */
function toggleRowPinnedState(rowKey, tableViewId, actionSource) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var isRowPinned = owa_mail_list_store_1.MailRowDataPropertyGetter.getIsPinned(rowKey, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            pinConversations_1.default([rowKey], tableView, !isRowPinned, actionSource);
            break;
        case 1 /* Message */:
            pinItems_1.default([rowKey], tableView, !isRowPinned, actionSource);
            break;
    }
}
exports.default = toggleRowPinnedState;
//# sourceMappingURL=toggleRowPinnedState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/toggleRowPinnedState.js
// module id = 5607
// module chunks = 62